import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';

import { CarePlanLookup } from '~clients/models';

// Coloured pill for a resolved lookup row (goal status, approach type), falling back to
// grey when the row has no colour.
const FALLBACK_COLOUR = '6c757d';

interface ComponentProps {
  lookup: CarePlanLookup;
  dataCy?: string;
}

const LookupBadge: React.FC<ComponentProps> = ({ lookup, dataCy }) => (
  <LookupStatusBadge
    status={{ tag: lookup.tag ?? lookup.id, name: lookup.name, colour: lookup.colour || FALLBACK_COLOUR }}
    dataCy={dataCy}
  />
);

export default LookupBadge;
